<template>
  <div class="warp warp_service" v-if="data">
    <Head></Head>
    <div class="modle_1" :style="'background: url('+data.img2+') center no-repeat; background-size: cover;'">
      <div class="txt_box">
        <div class="t1">
          {{data.encatname || '暂无数据'}}
        </div>
        <div class="t2">
          {{data.catname || ''}}
        </div>
        <div class="t3">

          {{data.seodescription || ''}}
        </div>
      </div>
      <ChildBan></ChildBan>
    </div>

    <div class="modle_6" v-if="data">

      <div  class="item"  v-for="(item,index) in data.list" :key="index">
        <div class="img" v-scroll-reveal style="  width: 100%;">
          <img :src="item.img1" style="width: 100%;" />
        </div>
        <div class="group cle">
          <div class="it " v-scroll-reveal v-for="(it,int) in item.list">
            <div class="it_img">

              <img :src="it.img1" />

            </div>
            <div class="title">
              <div class="t1 txtov">
                {{it.title}}
              </div>
              <div class="t2">
                {{it.tags}}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="item">
        <div class="img" style="height: 728px; width: 100%;"></div>
        <div class="group cle">
          <div class="it " v-for="(item,index) in 8">
            <div class="it_img">
              <i></i>
            </div>
            <div class="title">
              <div class="t1">
                JD
              </div>
              <div class="t2">
                （九数/数坊）
              </div>
            </div>
          </div>
        </div>
      </div> -->

    </div>


  </div>
</template>

<script>
  import {
    postcontAPI
  } from '../../../api/api.js'

  import Head from '@/components/Head.vue'
  import ChildBan from '@/components/ChildBan.vue'
  export default {
    components: {
      Head,
      ChildBan
    },
    data() {
      return {
        data: null

      }
    },
    methods: {
      //获取服务内容
      getList() {
        var that = this;
        postcontAPI().then(function(res) {
          console.log(res);
          that.data = res.data.data;
        }).catch(function(err) {
          console.log(err);
        })
      },
    },
    mounted() {
      this.getList();
    }

  }
</script>

<style lang="less" scoped>
  // 引入公共css3
  @import '../../assets/css3.css';

  template {
    min-height: 100%;
  }

  html,
  body {
    position: relative;
    min-height: 100%;
    overflow-x: hidden;
  }

  .modle_1 {
    height: 1200px;
    width: 100%;
    background: #f5f5f5;
    position: relative;

    .txt_box {
      position: relative;
      top: 500px;
      padding: 0px 50px;
      text-align: left;

      .t1 {
        color: #fff;
        font-size: 138px;
        font-weight: bold;
        margin-bottom: 20px;
      }

      .t2 {
        color: #fff;
        font-size: 80px;
      }

      .t3 {
        color: #fff;
        opacity: 0.5;
        margin-top: 115px;
        font-size: 37px;
      }
    }
  }

  .modle_6 {
    width: 95%;
    max-width: 1300px;
    margin: 0px auto;
    margin-top: 180px;

    .item {
      margin-bottom: 90px;

      .img {
        background: #f5f5f5;
        margin-bottom: 90px;
      }

      .group {
        position: relative;

        .it {
          width: 18.3%;
          display: inline-block;
          margin-bottom: 60px;
          margin-right: 2%;
          height: 208px;
         
          background: #fff;
          box-shadow: 0px 25px 99px 0px rgba(15, 37, 96, 0.1);

          .it_img {
            margin-top: 40px;

            img {
              width: 50px;
              height: 50px;
              background: #f5f5f5;
              display: inline-block;
              margin-bottom: 15px;
            }
          }

          .title {
            .t1 {
              font-size: 26px;
              margin-bottom: 0px;
              color: #3D3D3D;
            }

            .t2 {
              font-size: 16px;
              color: #3D3D3D;
            }
          }
        }

        .it:nth-child(5n) {
          margin-right: 0;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/service/service.vue